import {sitemap} from "../Sitemap";
import SidebarMenuItem from "./SidebarMenuItem";
import { useSelector, useDispatch } from "react-redux";
import { hidingSidebar } from "../../../store/actions/sidebar";
import classNames from "classnames";

const Sidebar = () => {
    const sidebar = useSelector((state) => state.sidebar)
    const dispatch = useDispatch();
    const handleClick = () => {
        dispatch(hidingSidebar())
    }
    const sidebarClassNames = {
        'side-navigation-wrapper': true,
        'enter-right': true,
        'slide-in-reset': true,
        'no-scrollbar': true,
        'active': sidebar !== 0,
        'slide-in': sidebar === 1
    }

    return (
        <aside className={classNames(sidebarClassNames)} data-no-scrollbar data-animation="slide-in">
            <div className="side-navigation-scroll-pane">
                <div className="side-navigation-inner">
                    <div className="side-navigation-header">
                        <div className="navigation-hide side-nav-hide" onClick={ () => handleClick() }>
                            <a>
                                <span className="icon-cancel medium"></span>
                            </a>
                        </div>
                    </div>
                    <nav className="side-navigation nav-block">
                        <ul>
                            {sitemap.filter(item => item.navigation).map(firstDepthMenu => (
                                <SidebarMenuItem key={firstDepthMenu.path} name={firstDepthMenu.name} to={firstDepthMenu.path} onClick={ () => handleClick() }>
                                    {firstDepthMenu.children &&
                                        <ul className="sub-menu">
                                            {
                                                firstDepthMenu.children.filter(item => item.navigation).map(secondDepthMenu => (
                                                    <SidebarMenuItem key={secondDepthMenu.path} name={secondDepthMenu.name} to={firstDepthMenu.path + '/' + secondDepthMenu.path} />
                                                ))
                                            }
                                        </ul>
                                    }
                                </SidebarMenuItem>
                            ))}
                        </ul>
                    </nav>
                    <div className="side-navigation-footer" />
                </div>
            </div>
        </aside>
    )
}

export default Sidebar;